type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export class ShowModal<P extends { closeModal: () => void }> {
  readonly type = 'SHOW_MODAL';
  constructor(
    public ModalComponent: React.ComponentClass<P> | React.FC<P> | React.ExoticComponent<P>,
    public modalProps: Omit<P, 'closeModal'>
  ) {}
}

export class CloseModal {
  readonly type = 'CLOSE_MODAL';
}

export type ModalAction = ShowModal<any> | CloseModal;
